// src/shared/hooks/usePageContentWithMeta.js
import { useGetContentDetail } from "../../assets/nodeApi/getApi/ContentGetApi";
import { useMeta } from "./useMeta";

export const usePageContentWithMeta = (pageName) => {
  const { data, isLoading, error } = useGetContentDetail(pageName);

  // Extract metadata block
  const metaSection =
    data?.content?.find((item) => item.type === "metadata")?.data ?? {};

  // Fallbacks if missing
  const defaultMeta = {
    title: `${pageName} | MySkill Club`,
    description: "",
    keywords: "",
  };

  // Merge CMS meta + defaults
  const mergedMeta = { ...defaultMeta, ...metaSection };

  // Apply to document
  useMeta(mergedMeta);

  return { data, isLoading, error, meta: mergedMeta };
};
